<template>
  <div class="file-upload-details">
    <div class="row">
      <div class="columns">
        <i class="el-icon-document" />

        <span class="text-latin">
          {{ fileName }}
        </span>
      </div>

      <div v-if="shouldShowIcon" class="columns shrink">
        <template v-if="uploading && !shouldShowProgressbar" />
        <span v-else-if="uploading">{{ percentage }}%</span>
        <i v-else-if="successful" class="el-icon-success" />
        <i v-else class="el-icon-error" />
      </div>
    </div>

    <ElProgress
      v-if="shouldShowProgressbar"
      class="file-upload-details__progress"
      :stroke-width="6"
      :percentage="percentage"
      :show-text="false"
    />
  </div>
</template>

<script>
export default {
  name: 'FileUploadDetails',
  props: {
    fileName: {
      type: String,
      required: true,
    },
    percentage: {
      type: Number,
      default: null,
    },
    uploading: {
      type: Boolean,
      default: null,
    },
    successful: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    shouldShowProgressbar() {
      return this.percentage !== null;
    },
    shouldShowIcon() {
      return this.uploading !== null || this.successful !== null;
    },
  },
};
</script>

<style lang="scss">
.file-upload-details {
  margin-top: $global-margin;
  margin-bottom: $global-margin / 3;

  &__progress {
    margin-top: $global-margin / 2;
  }

  .el-icon-success {
    color: $lb-color-primary;
  }

  .el-icon-error {
    color: $lb-color-alert;
  }
}
</style>
